import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'js/hooks/navigate';

import RaceListSliderCard from './RaceListSliderCard';
import FadeInContainer from '../common/FadeInContainer';

import style from './index.scss';
import { publicEventsAPIService } from '../../../../services/publicEventsAPI.service';
import { useCommonProperties } from '../Details/analytics/useCommonProperties';

const useGetLeaderboardOnClick = () => {
    const navigate = useNavigate();

    return useCallback((leaderboardId, leaderboardPage) => {
        const leaderBoardLink = leaderboardId && leaderboardPage ? `${leaderboardPage}/${leaderboardId}` : '' ;

        return () => {
            if (!leaderBoardLink) {
                return;
            }

            navigate(leaderBoardLink);
        };
    }, [navigate]);
};

const useGetParcelOnClick = () => {
    const navigate = useNavigate();

    return useCallback((parcelId) => {
        const parcelLink = parcelId ? `mystery-parcel/${parcelId}` : '';

        return () => {
            if (!parcelLink) {
                return;
            }

            navigate(parcelLink);
        };
    }, [navigate]);
};

let isAllowedToClick = true;

const setClickDelay = () => {
    setTimeout(() => {
        isAllowedToClick = true;
    }, 300);
};

export const ListSlider = ({ leaderboards, boardLength, ...rest }) => {
    const ref = React.createRef();
    const getLeaderboardOnClick = useGetLeaderboardOnClick();
    const getParcelOnClick = useGetParcelOnClick();

    const commonProperties = useCommonProperties();

    const trackMixPanelPromoCLickEvent = (lbId, mpId) => {
        publicEventsAPIService.trigger('promotion-opened', { ...commonProperties, ...{
                'overlay.engagementId': lbId || mpId
            } });
    };

    useEffect(() => {
        if (ref && ref.current) {
            let isDown = false;
            let startX;
            let scrollLeft;
            const refCurrent = ref.current;

            const onMouseMove = (e) => {
                if (!isDown) {
                    return;
                }
                isAllowedToClick = false;
                e.preventDefault();
                e.stopPropagation();
                const x = e.pageX - refCurrent.offsetLeft;
                const walk = (x - startX) * 1.5; // scroll-fast
                refCurrent.scrollLeft = scrollLeft - walk;
            };
            const onMouseLeave = (e) => {
                if (isDown) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                isDown = false;
                setClickDelay();
            };
            const onMouseUp = (e) => {
                if (isDown) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                isDown = false;
                setClickDelay();
            };
            const onMouseDown = (e) => {
                isDown = true;
                startX = e.pageX - refCurrent.offsetLeft;
                const { scrollLeft : scrollLeftTemp } = refCurrent;
                scrollLeft = scrollLeftTemp;
            };

            refCurrent.addEventListener('mousedown', onMouseDown);
            refCurrent.addEventListener('mouseleave', onMouseLeave);
            refCurrent.addEventListener('mouseup', onMouseUp);
            refCurrent.addEventListener('mousemove', onMouseMove);
            return function cleanup() {
                refCurrent.removeEventListener('mousedown', onMouseDown);
                refCurrent.removeEventListener('mouseleave', onMouseLeave);
                refCurrent.removeEventListener('mouseup', onMouseUp);
                refCurrent.removeEventListener('mousemove', onMouseMove);
            };
        }
    }, [ref]);

    const convertMPRegTimeToLbRegTime = time => time ? new Date(time * 1000).toISOString() : 0;

    return (
        <FadeInContainer className={style.sliderContainer}>
            <div ref={ref} className={style.overflowSlider}>
                {leaderboards.map(board => (
                    <RaceListSliderCard
                        key={(board.isParcel ? `${board.mysteryParcelId}parcel` : `${board.leaderboardId}board`)}
                        isParcel={board.isParcel} slider={true}
                        myeventRegistrationStartTime={board.isParcel ?
                            convertMPRegTimeToLbRegTime(board.registrationStartTime)
                            : board.registrationStartTime}
                        myeventRegistrationEndTime={board.isParcel ?
                            convertMPRegTimeToLbRegTime(board.registrationEndTime)
                            : board.registrationEndTime}
                        {...rest}
                        {...board}
                        onClick={() => {
                                if (!isAllowedToClick) {
                                    return;
                                }
                                trackMixPanelPromoCLickEvent(board.leaderboardId, board.mysteryParcelId);
                                const click = board.leaderboardId ?
                                    getLeaderboardOnClick(board.leaderboardId, rest.leaderboardPage) :
                            getParcelOnClick(board.mysteryParcelId);
                                click();
                            }
                        }
                    />
                ))}
            </div>
        </FadeInContainer>
    );
};

export default (props) => {
    const leaderboardPage = '/casino-leaderboard';

    return <ListSlider {...{ ...props, leaderboardPage }} />;
};
